/*
 * author: wendux
 * email: 824783146@qq.com
 * source code: https://github.com/wendux/Ajax-hook
 */

import {hook, unHook} from "./xhr-hook";
import {proxy, unProxy} from "./xhr-proxy";
// ah(ajax hook)
export var ah = {
    proxy,
    unProxy,
    hook,
    unHook,
};



// WEBPACK FOOTER //
// ./src/cdn.js